
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
import React from 'react';
import {MDBInput} from "mdb-react-ui-kit";

import {EMAIL_CAMPAIGN_NAMES,EMAIL_CAMPAIGN_DOWNLOAD,EMAIL_CAMPAIGN_LIST} from "../../constants";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import apiService from "../../variables/apiService";
// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Badge,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip
} from "reactstrap";

// import Table from '@mui/material/Table';

import TableContainer from '@mui/material/TableContainer';

import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';




import axios from 'axios';
import { useState,useEffect } from "react";
import moment from "moment";

import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';


const Detailedreports = (props) => {

  const[search,setSearch] = useState({
    name:"",
    date:""
  })
  const[name,setName] = useState([]);
  const[cname,setCName] = useState([]);
  
  const[showList,setShowList] = useState(false);
  const[emailLst,setEmailLst] = useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  const[validate,setValidate] = useState({
    message:"",
    notValid:false
  })

  const notificationAlertRef = React.useRef(null);

  const [isLoading, setIsLoading] = React.useState(true);

  const[filterList,setFilterLst] = useState([]);

  useEffect(()=>{
    getEmailNames();
    getEmailList(currentPage);
  },[])

  const getEmailNames=()=>{
    apiService.getData(EMAIL_CAMPAIGN_NAMES).then(res=>{
    
      setName(res.data.message);setCName(res.data.message)}).catch(err=>console.log("error===>",err))
  }

  const getEmailList=(page)=>{
  
    setCurrentPage(page);
    apiService.getData(EMAIL_CAMPAIGN_LIST+`?page=` +page).then(res=>{
     
      setEmailLst(res.data);
      setIsLoading(false)
      setFilterLst(res.data)
      }).catch(err=>
        {console.log("error===>",err); setIsLoading(false)})
      
  }
  



  const changeName = (e)=>{

    let cmpgnname = e.target.value;
   
    cmpgnname?setShowList(true):setShowList(false)
   
    let namesLiist = cname.filter((item,index)=>item.campaignname.toLowerCase().includes(cmpgnname.toLowerCase()));
    setName(namesLiist)
   
    setSearch({
      ...search,
      name:cmpgnname
    })
    
  }

  const generateXcel=()=>{
   
    if(search?.date&&search?.name){
      
      let selectedDate = moment(search.date).format("YYYY-MM-DD")
      
      apiService.getData(EMAIL_CAMPAIGN_DOWNLOAD+`?createdat=`+selectedDate+`&campaignname=`+search.name).then(res=>{exportToCSV(res.data.message);}).catch(err=>{
        let options = {};
    options = {
      place: "tr",
      message: err.response.data.message,
      type: "warning",
     
      autoDismiss: 3
    };
    notificationAlertRef.current.notificationAlert(options);
       })
      
    }else{
      setValidate({
        message:"please enter details",
        notValid:true
      } )

    }
   
  }



const exportToCSV = (apiData) => {
  
  const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(apiData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, search.name + fileExtension);
  
};

const PagingComponent = () => {
  return (
    <>
      {(() => {
        let paging = [];
        paging.push(
          <PaginationItem>
            <PaginationLink
              aria-label="Previous"
              onClick={(e) =>
                currentPage > 1 ? getEmailList(currentPage - 1) : ""
              }
            >
              <span aria-hidden={true}>
                <i
                  aria-hidden={true}
                  className="tim-icons icon-double-left"
                />
              </span>
            </PaginationLink>
          </PaginationItem>
        );
        for (let i = 1; i <= emailLst.numOfPages; i++) {
          paging.push(
            <PaginationItem className={currentPage == i && "active"}>
              <PaginationLink onClick={(e) => getEmailList(i)}>
                {i}
              </PaginationLink>
            </PaginationItem>
          );
        }
        paging.push(
          <PaginationItem>
            <PaginationLink
              aria-label="Next"
              onClick={(e) =>
                currentPage != emailLst.numOfPages
                  ? getEmailList(currentPage + 1)
                  : ""
              }
            >
              <span aria-hidden={true}>
                <i
                  aria-hidden={true}
                  className="tim-icons icon-double-right"
                />
              </span>
            </PaginationLink>
          </PaginationItem>
        );
        return paging;
      })()}
    </>
  );
};

const filterData = (e) =>{
let filter = e.target.value;
let c = parseInt(filter);
// let a = filterList?.message.filter((item,index)=>{console.log(typeof(c)) })
let a = filterList?.message.filter((item,index)=>{return (item.id.toString().includes(filter)||moment(item.createdat).format('DD-MM-YYYY').toString().includes(filter))})
setEmailLst({
  message: a,
  numOfPages:filterList.numOfPages
})

}
  return (
    
    <>
      <div className="content pb-0">
      <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <Row>
          <Col md="12">
            <Card className='mb-2'>
              <CardBody>
              <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md='3' sm="12" className="mt-4">
                  
                  <MDBInput label="name" type="text" value={search.name} onChange={(e)=>changeName(e)} />
                 
                  <ul className="searchScroll">
        {showList&&name?.map((suggestion, index) => (
        
          <li key={index} onClick={()=>{setSearch({...search,name:suggestion.campaignname});setShowList(false);setValidate({
            message:"",
            notValid:false
          } )}}>
            {suggestion.campaignname}
          </li>
        ))}
      </ul>
                  </Col>
                  <Col md='3' sm="12" className="mt-4">
                 
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date"
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                    value={search.date}
                    onChange={(val) =>{setSearch({...search,date:val._d});setValidate({
                      message:"",
                      notValid:false
                    } )}}
                  />
                  </Col>
                  <Col md='4' sm='6' className='pull-right' >
                                
              
                  <Button className=" btn-primary  btn-simple btn-icon btn-round mt-4" 
                  color="primary" 
                   data-placement="top"
                   id="tooltippdf"
                   type="button"
                   onClick={()=>generateXcel()}
                   >
                    <i className="tim-icons icon-cloud-download-93" />
                    
                  </Button>
                  {validate.notValid&&<span style={{color:"red"}}>{validate.message}</span>}
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltippdf"
                >
                  Export
                </UncontrolledTooltip>
                  </Col>
                 
                  <Col md='2' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
             
              <CardBody className="mb-0">
           
              <TableContainer component={Paper}  style={{"height" : "65vh"}}>
      <Table sx={{ minWidth: 650 ,paddingBottom:0}} aria-label="simple table" responsive striped>
        <thead>
         
          <tr >
              <th>S no </th>
              <th >Name  </th>
              <th >Email Id  </th>
              <th > Template</th>
              <th > Created on </th>
              <th > Status</th>
          </tr>
        </thead>
        <tbody>
         
          {
           
           emailLst.message?.length>0?emailLst?.message?.map((item,index)=>{
              return(
                <>
              <tr>
                <td>{item.id}</td>
                <td>{item.campaignname}</td>
                <td>{item.emailid}</td>
                <td>{item.templateid}</td>
                <td>{moment(item.createdat).format('DD-MM-YYYY')}</td>
               
                <td>{item.status == "1"?<Badge color="warning">Picked</Badge>:item.status == "2"?<Badge color="success">Sent</Badge>:item.status == "3"?<Badge color="info">Delivered</Badge>:item.status == "4"?<Badge color="info">Read</Badge>:""}</td>
              
              </tr>
              
              </>
              )
            }):(<tr><td colspan="6">No Records To Display</td></tr>)
          }
        </tbody>
      </Table>
    </TableContainer>
              </CardBody>
              {/* { emailLst?.length>0&&
              <Row>
              <Col md="12">
                <Pagination className="pull-right">
                  <PagingComponent />
                </Pagination>
              </Col>
            </Row>
            } */}
             { emailLst?.numOfPages>0&&
        <Col xs='12' className="pagecount">
        <ResponsivePagination
      current={currentPage}
      total={emailLst?.numOfPages}
      onPageChange={(newPage )=>{getEmailList(newPage)}}
    />
    </Col>
}
            </Card>
          </Col>
        </Row>

       
       
      </div>
    </>
  )
}

export default Detailedreports;